import { render, staticRenderFns } from "./ShippingMethod.vue?vue&type=template&id=af669f4c&"
import script from "./ShippingMethod.vue?vue&type=script&lang=js&"
export * from "./ShippingMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\themes-coder\\rawal\\rawal-laravel11\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af669f4c')) {
      api.createRecord('af669f4c', component.options)
    } else {
      api.reload('af669f4c', component.options)
    }
    module.hot.accept("./ShippingMethod.vue?vue&type=template&id=af669f4c&", function () {
      api.rerender('af669f4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/ShippingMethod.vue"
export default component.exports